new Vue({
    el: '#claim',
    data: {
        firstname: null,
        lastname: null,
        personalId: null,
        address: null,
        email: null,
        phone: null,
        message: null,

        products: [],
        claimTypes: [],
        contactTypes: [],
        intro: null,
        terms: null,

        selectedProducts: [],
        anotherProduct: null,

        selectedClaimTypes: [],
        selectedContactType: null,
        anotherClaimType: null,

        isSubmited: false,
        result: false,
        resultMessage: null,
        sendingData: false,

        anotherProductCheckbox: false,
        anotherClaimTypeCheckbox: false,

        agreeTerms: false,
        reg: /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,24}))$/
    },
    methods: {
        send: function (e) {
            e.preventDefault();
            var _this = this;
            if (_this.sendingData) { return; }
            _this.isSubmited = true;
            _this.resultMessage = null;
            valid = true;
            if (!_this.firstname || !_this.lastname || !_this.personalId || !_this.address || !_this.phone || !_this.email || !_this.message || !_this.agreeTerms || _this.personalId.length != 11 || !_this.reg.test(_this.email)) {
                valid = false;
            }
            if (valid) {
                _this.sendingData = true;
                axios.post('~/api/claim/send',
                    {
                        firstname: _this.firstname,
                        lastname: _this.lastname,
                        personalId: _this.personalId,
                        address: _this.address,
                        email: _this.email,
                        phone: _this.phone,
                        products: _this.selectedProducts,
                        otherProduct: _this.anotherProductCheckbox ? _this.anotherProduct : '',
                        claimTypes: _this.selectedClaimTypes,
                        otherClaimType: _this.anotherClaimTypeCheckbox ? _this.anotherClaimType : '',
                        contactType: _this.selectedContactType['title'],
                        message: _this.message,
                        captchaVal: $("#g-recaptcha-response").val(),
                        languageId: window.languageId
                    }).then(function (response) {
                        _this.result = response.data.success;
                        _this.resultMessage = response.data.message;
                    }).catch(function (e) {
                        _this.result = false;
                        _this.resultMessage = window.errorPhrase;
                    }).finally(function (e) {
                        _this.sendingData = false;
                    });
            }
            _this.isSubmited = true;

            return false;
        }
    },
    mounted: function () {
        var _this = this;
        if (!!window.claimFormSettings) {
            _this.products = window.claimFormSettings.products;
            _this.claimTypes = window.claimFormSettings.claimTypes;
            _this.contactTypes = window.claimFormSettings.contactTypes;
            _this.selectedContactType = _this.contactTypes[0];
            _this.intro = window.claimFormSettings.intro;
            _this.terms = window.claimFormSettings.terms;
        }
    }
})